import { type FC } from 'react';

import { ClipLoader, Icon } from '@wf/components';

import useDownloadLicense from '../../../../License/hooks/useDownloadLicense';

interface IPrintLicenseBtn {
  id: string;
}

const PrintLicenseBtn: FC<IPrintLicenseBtn> = ({ id }) => {
  const { handleDownloadLicense, isDownloading } = useDownloadLicense(id);

  return isDownloading ? <ClipLoader size={20} /> : <Icon name="ic_print" onClick={handleDownloadLicense} />;
};

export default PrintLicenseBtn;
